<!-- Columns on the Funds. -->
<div class="table-fms max-height-80vh">
  <table>
    <thead>
    <tr>
      <th class="fix-w-1"></th>
      <th
        [attr.colspan]="(isAdmin && (orgAccess.isOrganizationAdmin || orgAccess.isSuperAdmin)) ? 4 : 3"
        class="no-hover">
      </th>
      <th class="blank-space no-hover"></th>
      <th colspan="3" class="text-center">Registration</th>
      <th class="blank-space no-hover"></th>
      <th colspan="4" class="text-center">Dates</th>
      <th class="blank-space no-hover"></th>
      <th colspan="2"></th>
    </tr>
    <tr>
     <!-- Go through all fields of the form and add them as columns. -->
     <th class="fix-w-1"
      data-qa="th-with-menu">
      <app-three-dots-menu [matMenuTriggerFor]="menu"/>
      <mat-menu #menu="matMenu">
        <ul class="list">
          <app-drop-down-item
            data-qa="fund-table-excel"
            class="width-100pcnt"
            [text]="'Export'"
            [iconNameAndStyling]="'excel.svg'"
            (click)="exportExcel()">
          </app-drop-down-item>
        </ul>
      </mat-menu>
     </th>
      <th
        data-qa="th-fund-id"
        appSort
        [attr.colspan]="(isAdmin && (orgAccess.isOrganizationAdmin || orgAccess.isSuperAdmin)) ? 3 : 2"
        [arr]="[groupedFunds.funds, groupedFunds.spvs]"
        [keySelector]="FundSorting.byName">
        Fund
      </th>
      <th class="fix-w-3p5"
          appSort
          [arr]="[groupedFunds.funds, groupedFunds.spvs]"
          [keySelector]="FundSorting.byFundId">
        ID
      </th>
      <th class="blank-space no-hover"></th>
      <th class="fix-w-5p5"
          appSort
          [arr]="[groupedFunds.funds, groupedFunds.spvs]"
          [keySelector]="FundSorting.byRegistrationState">
        State
      </th>
      <th class="fix-w-5p5"
          appSort
          [arr]="[groupedFunds.funds, groupedFunds.spvs]"
          [keySelector]="FundSorting.byRegistrationNumber">
        Number
      </th>
      <th
        data-qa="th-reg-date"
        class="fix-w-5p5"
        appSort
        [arr]="[groupedFunds.funds, groupedFunds.spvs]"
        [keySelector]="FundSorting.byRegistrationDate">
        Date
      </th>
      <th class="blank-space no-hover"></th>
      <th
        data-qa="th-initial-closing"
        class="fix-w-5p5"
        appSort
        [arr]="[groupedFunds.funds, groupedFunds.spvs]"
        [keySelector]="FundSorting.byInitClosing">
        Initial closing
      </th>
      <th class="fix-w-5p5"
          appSort
          [arr]="[groupedFunds.funds, groupedFunds.spvs]"
          [keySelector]="FundSorting.byFinClosing">
        Final closing
      </th>
      <th class="fix-w-5p5"
          appSort
          [arr]="[groupedFunds.funds, groupedFunds.spvs]"
          [keySelector]="FundSorting.byInvPeriod">
        Investment period
      </th>
      <th class="fix-w-5p5"
          appSort
          [arr]="[groupedFunds.funds, groupedFunds.spvs]"
          [keySelector]="FundSorting.byFundTerm">
        Fund's term
      </th>
      <th class="blank-space no-hover"></th>
      <th class="fix-w-5p5"
          appSort
          [arr]="[groupedFunds.funds, groupedFunds.spvs]"
          [keySelector]="FundSorting.byManagementCompanyName">
        Management company
      </th>
      <th class="fix-w-3p5">SPV</th>
    </tr>
    </thead>
    <ng-container *ngFor="let group of shownGroups">
      <tbody cdkDropList (cdkDropListDropped)="drop($event, groupedFunds[group])">
      <tr *ngIf="groupedFunds[group].length">
        <td class="fix-w-1"></td>
        <td class="fix-w-2" [attr.data-qa]="'open-close-' + group + '-funds'" (click)="show[group] = !show[group]">
          <app-table-group-icon [opened]="show[group]"></app-table-group-icon>
        </td>
        <td colspan="100%" class="bold600">
          {{group === 'funds' ? 'Funds' : 'SPVs'}}
        </td>
      </tr>
      <ng-container *ngFor="let f of groupedFunds[group]; let i = index">
        <ng-container *ngIf="show[group]">
          <tr
            [attr.data-qa]="f.name + '-fund-row'"
            class="example-box draggable"
            cdkDrag
            id="fund"
            [cdkDragDisabled]="!(isAdmin && (orgAccess.isOrganizationAdmin || orgAccess.isSuperAdmin))">
            <td class="fix-w-1"></td>
            <td *ngIf="!(isAdmin && (orgAccess.isOrganizationAdmin || orgAccess.isSuperAdmin))"></td>
            <td
              *ngIf="isAdmin && (orgAccess.isOrganizationAdmin || orgAccess.isSuperAdmin)"
              data-qa="drag-td"
              id="twoLines"
              class="fix-w-2"
              cdkDragHandle>
              <app-all-icons [iconNameAndStyling]="'drop-icon.svg; drag-svg icon-size-1p375 cursor-grab'"/>
            </td>
            <td *ngIf="isAdmin && (orgAccess.isOrganizationAdmin || orgAccess.isSuperAdmin)"
                class="fix-w-2">
              <app-three-dots-menu [matMenuTriggerFor]="fundMenu" id="three-dots-fund-menu"/>
              <mat-menu #fundMenu="matMenu">
                <ul class="list">
                  <app-drop-down-item
                    data-qa="fund-edit"
                    class="width-100pcnt"
                    [text]="'Edit fund'"
                    [iconNameAndStyling]="'edit-outline.svg'"
                    (click)="update(f)">
                  </app-drop-down-item>

                  <app-drop-down-item
                    data-qa="fund-copy"
                    class="width-100pcnt"
                    [text]="'Duplicate fund'"
                    [iconNameAndStyling]="'copy-outline.svg'"
                    (click)="copy(f)">
                  </app-drop-down-item>
                </ul>
              </mat-menu>
            </td>
            <td [attr.data-qa]="f.name + '-name-with-tooltip'">
              <app-text-with-tooltip
                [id]="fundNameId + i"
                [text]="f.name"
                [positionType]="'left'"/>
            </td>
            <td class="fix-w-3p5">
              {{f.fundId}}
            </td>
            <td class="blank-space"></td>
            <!--     Registration       -->
            <td class="fix-w-5p5">
              <span> {{f.registration}}</span>
            </td>
            <td class="fix-w-5p5">
              {{f.registrationNumber}}
            </td>
            <td class="fix-w-5p5">
              <span [ngClass]="dateArray[group][i][0] ? 'main-8' : ''">
                {{f.registrationDate | date : 'MMM d, y'}}
              </span>
            </td>
            <td class="blank-space"></td>
            <!--     Closing/Period/Term       -->
            <td class="fix-w-5p5">
              <span [ngClass]="dateArray[group][i][1]  ? 'main-8' :  '' ">
                {{f.initialClosing | date : 'MMM d, y'}}
              </span>
            </td>
            <td class="fix-w-5p5">
              <span [ngClass]="dateArray[group][i][2] ? 'main-8' :  ''">
                {{f.finalClosing | date : 'MMM d, y'}}
              </span>
            </td>
            <td class="fix-w-5p5">
              <span [ngClass]="dateArray[group][i][3] ? 'main-8' :  ''">
                {{f.investmentPeriod | date : 'MMM d, y'}}
              </span>
            </td>
            <td class="fix-w-5p5">
              <span [ngClass]="dateArray[group][i][4] ? 'main-8' :  ''">
                {{f.fundTerm | date:'MMM d, y'}}
              </span>
            </td>
            <td class="blank-space"></td>
            <!--    Misc        -->
            <td class="fix-w-5p5"
                [id]="managementCoId + i"
                (mouseover)="activateToolTip(managementCoId + i, f.managementCompany?.name, 16)"
                (mouseleave)="deactivateToolTip()">
              {{f.managementCompany?.name | linkShort : 20}}
            </td>
            <td class="fix-w-3p5">
              <app-checkbox
                [attr.data-qa]="f.name + '-spv-checkbox'"
                [disabled]="!(isAdmin && (orgAccess.isOrganizationAdmin || orgAccess.isSuperAdmin))"
                [checked]="f.spv"
                (checkBoxClicked)="updateSvp(f)">
              </app-checkbox>
            </td>
          </tr>
        </ng-container>
      </ng-container>
      </tbody>
    </ng-container>
  </table>
  <app-tooltip
    *ngIf="toolTipSettings?.show"
    [coordinates]="toolTipSettings.coordinates"
    [title]="toolTipSettings.title">
  </app-tooltip>
</div>
